export default __webpack_public_path__ + "static/media/dialyysi.d4bc0a42.svg";